import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { environment } from 'projects/b2c/src/environments/environment';
import { SubSink } from 'subsink';
import { FlightService } from '../../flight.service';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';

const b2b_url = `${environment.b2b_url}/b2b`

@Component({
    selector: 'app-payment-details',
    templateUrl: './payment-details.component.html',
    styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit, OnDestroy {

    @Output() someEvent = new EventEmitter<any>();
    @Input() userOne;
    private subSunk = new SubSink();
    commitBooking: {} = {};
    isLoading: boolean = true;
    regConfig: FormGroup;
    flights: any;
    flight: any;
    flightsFare: any;
    price: any;
    attr: any;
    appReference: any;
    ReservationResultIndex: any;
    isPaymentGatewayEnabled:boolean=false;
    terms: boolean = false;
    showPaymentDetails: boolean;
    paymentForm: FormGroup;
    submitted: boolean;
    paymentData: any;
    srcUrl: any;
    paymentGateways: any;

    constructor(
        private router: Router,
        private flightService: FlightService,
        private util: UtilityService,
        private fb: FormBuilder,
        private apiHandlerService: ApiHandlerService,
        private activatedRoute: ActivatedRoute,
        private swalService: SwalService,
        private cdr: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.getPaymentGateWays();
        this.createPaymentForm();
        this.activatedRoute.queryParams.subscribe(params => {
            this.appReference = (params.AppReference).replace("/", "");
        })
        this.flightService.FinalBookingResponse.subscribe(res => {
            if (res) {
                this.flight = res;
                this.flightsFare = res;
                this.price = res.Price;
                this.attr = res.Attr;
            }
        })
        this.createForm();
    }

    createForm() {
        this.regConfig = this.fb.group({
            Address: new FormControl('', [Validators.required, Validators.maxLength(120), Validators.minLength(2)]),
            Address2: new FormControl('', [Validators.maxLength(120), Validators.minLength(2)]),
            City: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
            State: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
            PostalCode: new FormControl('', [Validators.required, Validators.pattern(this.util.regExp.zipCode), Validators.maxLength(10)]),
            Email: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(30), Validators.pattern(this.util.regExp.email)]),
            PhoneCode: new FormControl('+1', [Validators.required, Validators.maxLength(6), Validators.pattern(this.util.regExp.phoneCode)]),
            Contact: new FormControl('', [Validators.required, Validators.pattern(this.util.regExp.phoneNo)]),
            Country: new FormControl('', [Validators.required]),
            Deals: new FormControl('', [Validators.required]),
        })
    }

    createPaymentForm() {
        this.paymentForm = this.fb.group({
            paymentMethod: new FormControl('', [Validators.required])
        });
    }

    hasError = (controlName: string, errorName: string) => {
        return ((this.submitted || this.paymentForm.controls[controlName].touched) && this.paymentForm.controls[controlName].hasError(errorName));
    }

    hide() {
        this.showPaymentDetails = false;
    }

    paymentConfirm() {
        this.submitted = true;
        if (!this.terms) {
            return;
        }
        if (!this.paymentForm.valid)
            return;
        if (this.paymentForm.value.paymentMethod && this.paymentForm.value.paymentMethod != '') {
            switch (this.paymentForm.value.paymentMethod) {
                case 'nagad':
                    this.nagadPayment();
                    break;
                case 'bKash':
                    this.srcUrl = `${b2b_url}/paymentGateway/${this.appReference}`;
                    window.location.replace(this.srcUrl);
                    break;
                case 'sslCommerz':
                    this.sslCommerzPayment();
                    break;

                default:
                    break;
            }
        }
    }

    getCommitBooking() {
        this.subSunk.sink = this.flightService.CommitBookingResponse.subscribe(res => {
        });
        this.flight = JSON.parse(sessionStorage.getItem('paymentPageLoadData'))
    }

    proceedPayment() {
        if (this.appReference && this.appReference != "") {
            this.router.navigate(['/flight/booking-confirm'], {
                queryParams: {
                    AppReference: this.appReference,
                    ReservationResultIndex: this.ReservationResultIndex
                }
            });
        }
    }

    payNow() {
        this.showPaymentDetails = true;
    }

    nagadPayment() {
        let date = (new Date().getTime()).toString();
        let invoiceNumber= this.flightService.setInvoiceNumber(this.appReference);
        this.subSunk.sink = this.apiHandlerService.apiHandler('executePayment', 'post', {}, {}, {
            app_reference: this.appReference,
            order_id: `FBPI${date.substr(10)}${date.substr(0, 7)}${date.substr(7)}`,
            payment_type: 'nagad',
            merchantInvoiceNumber: invoiceNumber
        }).subscribe(resp => {
            if (resp.statusCode == 201 || resp.statusCode == 200) {
                window.location = resp.data.callBackUrl
            }
        })
    }

    callPnrTicket(data) {
        let TicketData = {
            AppReference: data.BookingAppReference,
            booking_source: data.booking_source
        }
        this.subSunk.sink = this.apiHandlerService.apiHandler('pnrRetrieve', 'post', '', '', TicketData).subscribe(res => {
            if (res) {
                //  this.confirmedData = res.data.FinalBooking.BookingDetails;
                this.util.writeStorage("ticketCache", res.data.FinalBooking.BookingDetails, sessionStorage)
                //  this.showConfirmTicket = false;
            }
        });
    }

    sslCommerzPayment() {
        let date = (new Date().getTime()).toString();
        this.subSunk.sink = this.apiHandlerService.apiHandler('sslTransactionInit', 'post', {}, {}, {
            app_reference: this.appReference,
            order_id: `FBPI${date.substr(10)}${date.substr(0, 7)}${date.substr(7)}`,
            payment_type: 'sslCommerz'
        }).subscribe(resp => {
            if (resp.statusCode == 201 || resp.statusCode == 200) {
                window.location = resp.data.ssl
            }
        })
    }

    getPaymentGateWays() {
        this.apiHandlerService.apiHandler('getPaymentGateWays', 'POST', '', '', {}).subscribe(res => {
            if (res && ([200, 201].includes(res.statusCode))) {
                if (res.data && res.data.length > 0) {
                    res.data = res.data.filter(paymentGateway => paymentGateway.remarks !== 'Wallet')
                    this.paymentGateways = res.data;
                    if (res.data && res.data.length > 0) {
                        this.isPaymentGatewayEnabled = true;
                        this.cdr.detectChanges();
                    }
                    else {
                        this.isPaymentGatewayEnabled = false;
                        this.cdr.detectChanges();
                    }
                }
                else {
                    this.isPaymentGatewayEnabled = false;
                    this.cdr.detectChanges();
                }
            }
            else {
                this.swalService.alert.oops('Some thing went wrong');
                this.isPaymentGatewayEnabled = false;
                this.cdr.detectChanges();
            }
        }, (err) => {
            if (err && err.err && err.error.msg) {
                this.swalService.alert.oops(err.error.msg);
                this.isPaymentGatewayEnabled = false;
                this.cdr.detectChanges();
            }
        });
    }

    openStaticPage(page_title) {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['cms/'+page_title])
        );
        window.open('#' + url, '_blank');
    }

    onTerms(e) {
        this.terms = e
    }

    ngOnDestroy() {
        this.subSunk.unsubscribe();
    }
}
